export default __webpack_public_path__ + "static/pikachu-cb81c8c0d7c92787bb35bf59d95fa3a8.png";